import React, { useEffect, useState } from "react";
import "../../styles/Industries.css";
import { RiArrowRightSLine } from "react-icons/ri";
import Hospitality_bg_img from "../../bg_images/I_hospitality_bg_img.png";
import { useNavigate } from "react-router-dom";
import { HiArrowNarrowRight } from "react-icons/hi";
import { MdOutlineKeyboardArrowRight } from "react-icons/md";
import { MdOutlineKeyboardArrowLeft } from "react-icons/md";

const Servicecards = [
  {
    title: "Enhancing Guest Experience",
    text: " We leverage technology to personalize interactions, offer seamless digital services, and exceed guest expectations in a competitive market. ",
  },
  {
    title: " Optimizing Operational Efficiency ",
    text: " We reduce costs, improve staff productivity, and streamline workflows through automation and integrated IT systems. ",
  },
  {
    title: " Staying Competitive ",
    text: " We embrace the latest technology trends to attract modern travelers and maintain a leading edge in the evolving hospitality landscape. ",
  },
  {
    title: " Managing Data Security ",
    text: " We protect against cyber threats and ensure compliance with data privacy regulations to maintain guest trust and avoid costly breaches. ",
  },
  {
    title: " Adapting to Changing Demands ",
    text: " We implement flexible and scalable IT solutions that can adapt to fluctuating occupancy rates and evolving guest preferences. ",
  },
];

const Hospitality = () => {
  const navigate = useNavigate();


  const [currentIndex, setCurrentIndex] = useState(0);
      const [visibleServicecards, setVisibleServicecards] = useState(3);
    
      
      useEffect(() => {
        const updateVisibleServicecards = () => {
          if (window.innerWidth <= 768) {
            setVisibleServicecards(1); 
          } else {
            setVisibleServicecards(3); 
          }
        };
    
        updateVisibleServicecards();
        window.addEventListener("resize", updateVisibleServicecards);
        return () =>
          window.removeEventListener("resize", updateVisibleServicecards);
      }, []);
    
      const handleNext = () => {
        if (currentIndex + visibleServicecards < Servicecards.length) {
          setCurrentIndex(currentIndex + 1);
        }
      };
    
      const handlePrev = () => {
        if (currentIndex > 0) {
          setCurrentIndex(currentIndex - 1);
        }
      };
    

  return (
    <div className="Industries">
      <div
        className="I_sec1"
        style={{ backgroundImage: `url(${Hospitality_bg_img})` }}
      >
        <h5>
          Industries <RiArrowRightSLine className="servrighticon" /> Hospitality
        </h5>
        <h1> Elevate Guest Experiences with Smart Hospitality Tech </h1>
        <p>
          We provide tailored IT solutions to empower hotels, restaurants, and
          hospitality businesses to thrive.
        </p>
        <button
          onClick={() => navigate("/services/ApplicationDevelopment")}
          className="S_sec1_btn1"
        >
          Discover our solutions
          <HiArrowNarrowRight className="psec1arrow" />
        </button>
      </div>

      {/* Section 2 */}

      <div className="I_sec2">
        <h2>What we offer Our Hospitality Customers</h2>
        <section className="I_sec2_cardsContainer">
          <section className="I_sec2_cards">
            <h6>
              <img
                className="I_sec2_icon"
                src="../svg/H_sec2_icon1.svg"
                alt=""
              />
              Enchanced Guest Connectivity
            </h6>
            <p>
              Reliable and secure Wi-Fi solutions to keep your guests connected
              and satisfied throughout their stay or visit.
            </p>
          </section>
          <section className="I_sec2_cards">
            <h6>
              <img
                className="I_sec2_icon"
                src="../svg/H_sec2_icon2.svg"
                alt=""
              />
              Streamlined Operations
            </h6>
            <p>
              Efficient Property Management Systems (PMS) and Point of Sale
              (POS) integrations for seamless management of bookings, services,
              and transactions.
            </p>
          </section>
          <section className="I_sec2_cards">
            <h6>
              <img
                className="I_sec2_icon"
                src="../svg/H_sec2_icon3.svg"
                alt=""
              />
              Data-Driven Insights
            </h6>
            <p>
              Analytics and reporting tools to understand guest behavior,
              optimize services, and personalize experiences for increased
              satisfaction and loyalty.
            </p>
          </section>
          <section className="I_sec2_cards">
            <h6>
              <img
                className="I_sec2_icon"
                src="../svg/H_sec2_icon4.svg"
                alt=""
              />
              Robust Cybersecurity
            </h6>
            <p>
              Protect sensitive guest and business data with comprehensive
              security solutions tailored to the hospitality environment.
            </p>
          </section>
        </section>
        <button onClick={() => navigate("/contact")} className="I_sec2_btn1">
          Schedule a free consultation
          <HiArrowNarrowRight className="psec1arrow" />
        </button>
      </div>

      {/* Section 3 */}

      <div className="S_carousel-container">
        <h2 className="S_carousel-title">
          Solving the Key Challenges in Hospitality
        </h2>
        <div className="S_carousel-wrapper">
          <button
            className="arrow left-arrow"
            onClick={handlePrev}
            disabled={currentIndex === 0}
          >
            <MdOutlineKeyboardArrowLeft className="S_rightArrow" />
          </button>

          <div className="S_carousel">
            <div
              className="S_carousel-track"
              style={{
                transform: `translateX(-${
                  currentIndex * (100 / visibleServicecards)
                }%)`,
              }}
            >
              {Servicecards.map((card, index) => (
                <div className="S_carousel-card" key={index}>
                  <h3>{card.title}</h3>
                  <div className="underline"></div>
                  <p>{card.text}</p>
                </div>
              ))}
            </div>
          </div>

          <button
            className="arrow right-arrow"
            onClick={handleNext}
            disabled={currentIndex + visibleServicecards >= Servicecards.length}
          >
            <MdOutlineKeyboardArrowRight className="S_rightArrow" />
          </button>
        </div>
      </div>

      {/* Section 4 */}

      <div className="I_sec4">
        <section className="I_sec4_left">
          <h1>Case Study</h1>
          <h6>
            How Arshil ensured guest satisfaction with IT solutions for
            hospitality industry
          </h6>
          <p>
            Arshil expertly designed a mobile app for a leading commercial event
            management company, enabling them to streamline their event planning
            and management processes. We delivered an intuitive solution that
            empowers the company to efficiently organize, manage, and track
            events in real-time.
          </p>
          {/* <p>
            Discover how we were able to implement a state of the art solution
            for the customer.
          </p> */}
        </section>
        <section className="I_sec4_right">
          <img
            className="I_sec4_img1"
            src="../images/I_hospitality_img.png"
            alt="I_hospitality_img"
          />
        </section>
      </div>

      {/* Section 5  */}

      <div className="I_sec5">
        <section className="I_sec5_left">
          <h4>Ready to Transform Your Hospiltality Business?</h4>
          <p>
            Let's discuss how our IT solutions can drive your success and
            elevate your guest experiences.
          </p>
        </section>
        <section className="I_sec5_right">
          <button onClick={() => navigate("/contact")}>
            Schedule a Free Consultation
            <HiArrowNarrowRight className="I_sec5_arrow_right" />
          </button>
        </section>
      </div>
    </div>
  );
};

export default Hospitality;
